// =============================================================================
// Composer — write a message. Text + attach photo + attach voice + @mention.
//
// Calls onSend({ body, mentions }) when the user submits. Parent decides
// what to do with attachments (upload, then call sendMessage with the URL).
// =============================================================================
import React, { useRef, useState } from "react";

export function Composer({ placeholder = "Message…", onSend, onAttach, hint }) {
  const [body, setBody] = useState("");
  const [sending, setSending] = useState(false);
  const ref = useRef(null);

  async function submit() {
    const trimmed = body.trim();
    if (!trimmed || sending) return;
    setSending(true);
    try {
      const mentions = extractMentions(trimmed);
      await onSend({ body: trimmed, mentions });
      setBody("");
      if (ref.current) ref.current.focus();
    } finally {
      setSending(false);
    }
  }
  function onKeyDown(e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  }
  return (
    <div className="chat-composer-wrap">
      <div className="chat-composer">
        <textarea
          ref={ref}
          className="chat-composer-input"
          rows={2}
          placeholder={placeholder}
          value={body}
          onChange={(e) => setBody(e.target.value)}
          onKeyDown={onKeyDown}
          disabled={sending}
        />
        <div className="chat-composer-bar">
          <div className="chat-composer-tools">
            <button type="button" className="chat-cb" title="Attach photo" onClick={() => onAttach?.("photo")}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="17" height="17">
                <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/>
              </svg>
            </button>
            <button type="button" className="chat-cb" title="Voice note" onClick={() => onAttach?.("voice")}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="17" height="17">
                <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/>
              </svg>
            </button>
            <button type="button" className="chat-cb" title="@mention">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="17" height="17">
                <circle cx="12" cy="12" r="4"/><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8"/>
              </svg>
            </button>
          </div>
          {hint && <span className="chat-composer-hint">{hint}</span>}
          <button type="button" className="chat-composer-send" disabled={sending || !body.trim()} onClick={submit}>
            {sending ? "Sending…" : "Send"}
          </button>
        </div>
      </div>
    </div>
  );
}

function extractMentions(text) {
  const matches = [...text.matchAll(/@([a-zA-Z0-9_-]+)/g)];
  return [...new Set(matches.map((m) => m[1].toLowerCase() === "sevric" ? "sevric-ai" : m[1]))];
}
